import { Animation } from "./tools/index"

/**
 * @returns {Number} Returns the integer part of value, without decimals, rounded to lower.
 */
function trunc(value) {
	return value | 0
}

/**
 * @constructor
 * @augments Tee.Animation
 * @class Animates Series marks items.
 */
let MarksAnimation = function (target) {
	Animation.call(this, target)

	if (target && target instanceof Tee.Series) {
		this.series = target
		this.chart = target.chart
	} else this.series = null

	this.current = -1

	var m = this.series.marks,
		o = this,
		old

	function marksText(series, index, result) {
		if (index <= o.current) return result
		else return ""
	}

	this.start = () => {
		old = m.ongettext
		m.ongettext = marksText
	}

	this.stop = function () {
		m.ongettext = old
		this.current = -1
	}

	this.doStep = f => {
		o.current = trunc(o.series.data.values.length * f)
	}
}

MarksAnimation.prototype = new Animation()

export { MarksAnimation }
